import React from "react";

function LoadingAnimation() {
  return (
    <div
      className="m-loading-animation m-loading-animation--component"
      role="alert"
    >
      <span className="a-hidden">Loading…</span>
      <img
        src="/themes/rosenfeld/assets/images/loader.svg"
        className="m-loading-animation__image"
        role="presentation"
        alt=""
      />
    </div>
  );
}

export default LoadingAnimation;
